var _excluded = ["label", "labelProps", "isRequired", "isAvailableCounter", "isWrapFormGroup", "name", "placeholder", "value", "type", "error", "formGroupProps", "className", "additionalClassName", "errorAdditionalClassName", "sizeLg", "inputmask"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Counter } from 'components/form/fields/Counter';
import { Label } from '@collaborator/npm_modules/dist/components/form/label';
import Inputmask from 'inputmask';
import { When } from 'react-if';
import useMergedRefs from '@restart/hooks/useMergedRefs';
var Input = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
      labelProps = _ref.labelProps,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$isAvailableCount = _ref.isAvailableCounter,
      isAvailableCounter = _ref$isAvailableCount === void 0 ? false : _ref$isAvailableCount,
      _ref$isWrapFormGroup = _ref.isWrapFormGroup,
      isWrapFormGroup = _ref$isWrapFormGroup === void 0 ? true : _ref$isWrapFormGroup,
      name = _ref.name,
      placeholder = _ref.placeholder,
      value = _ref.value,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      error = _ref.error,
      _ref$formGroupProps = _ref.formGroupProps,
      formGroupProps = _ref$formGroupProps === void 0 ? {} : _ref$formGroupProps,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'form-control' : _ref$className,
      additionalClassName = _ref.additionalClassName,
      errorAdditionalClassName = _ref.errorAdditionalClassName,
      sizeLg = _ref.sizeLg,
      inputmask = _ref.inputmask,
      props = _objectWithoutProperties(_ref, _excluded);

  var refInput = useRef();
  var refs = useMergedRefs(forwardedRef, refInput);
  useEffect(function () {
    if (!inputmask) {
      return;
    }

    Inputmask(inputmask).mask(refInput.current);
  }, []);

  var wrapFormGroup = function wrapFormGroup(content) {
    if (isWrapFormGroup) {
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "form-group"
      }, formGroupProps), content);
    }

    return content;
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/React.createElement(Label, _extends({
      label: label,
      isRequired: isRequired,
      htmlFor: props.id || name
    }, labelProps));
  };

  var renderContent = function renderContent() {
    var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(When, {
      condition: type !== 'checkbox'
    }, renderLabel()), /*#__PURE__*/React.createElement("input", _extends({
      ref: refs,
      type: type,
      name: name,
      className: classNames(className, additionalClassName, {
        'is-invalid': error
      }, {
        'form-control-lg': sizeLg
      }),
      placeholder: placeholder,
      id: name,
      value: value
    }, props)), /*#__PURE__*/React.createElement(When, {
      condition: type === 'checkbox'
    }, renderLabel()), /*#__PURE__*/React.createElement("div", {
      className: classNames('invalid-feedback', errorAdditionalClassName)
    }, error));

    if (isAvailableCounter) {
      return /*#__PURE__*/React.createElement("div", {
        className: "position-relative"
      }, /*#__PURE__*/React.createElement(Counter, {
        isAvailable: isAvailableCounter,
        value: value
      }), content);
    }

    return content;
  };

  return wrapFormGroup(renderContent());
});
export { Input };